
import React from 'react';
import { Card } from '@/components/ui/card';

interface ProductListProps {
  offerProducts: any[];
  globalProducts: any[];
  selectedProductIds: string[];
  showProductImages: boolean;
  onToggleProduct?: (productId: string) => void;
  isBundle?: boolean;
}

const ProductList: React.FC<ProductListProps> = ({
  offerProducts,
  isBundle = false
}) => {
  return (
    <Card className=" overflow-hidden h-full">
      {/* Minimal implementation - would need further updates based on how product details are displayed */}
    </Card>
  );
};

export default ProductList;
